import { render, staticRenderFns } from "./AssignmentWithdrawRules.vue?vue&type=template&id=2a58826a&scoped=true&"
import script from "./AssignmentWithdrawRules.vue?vue&type=script&lang=js&"
export * from "./AssignmentWithdrawRules.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentWithdrawRules.vue?vue&type=style&index=0&id=2a58826a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58826a",
  null
  
)

export default component.exports